import script from "./PaymentsTableTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentsTableTab.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentsTableTab.vue?vue&type=style&index=0&id=2ab4d9b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab4d9b0"]])

export default __exports__